import { OEEnvironment } from './environment.type';

export const environment = {
	appMeta: {
		env: OEEnvironment.DEV,
	},
	dayBeforeShowDeletionProductAlert: 13,
	apiVersion: '2.0',
	production: false,
	disableAnnoyingBehaviourForDevs: false,
	auth: {
		redirectUri: 'https://dev.myzeiss-store.zeiss.com/',
		clientId: '516b7ae6-c35f-4aa6-9875-351aa501939d',
		issuer: 'https://b2cstage.zeiss.com/483f449b-6a0d-4354-b7e7-37113e7d4ca1/v2.0/',
		discoveryDocument:
			'https://id-ip-stage.zeiss.com/OAuth/OpenidConfiguration?p=B2C_1A_ZeissIdWithAuthZSignIn',
	},
	zeissIdURL: 'https://id-stage.zeiss.com/profile/index',
	myZeissUrl: 'https://www.stage-internet.zeiss.com/vision-care/myzeiss',
	academyLink: 'https://academy.com/',
	visuStoreLink: 'https://q-live-vis.ecommerce.zeiss.com/login?seamlessSSO=true',
	apiBaseUrl: 'https://api-vision-dev-d7g3dge6gse5cba0.a03.azurefd.net/public/api/oe',
	toastClickThrough: false,
};
